export default __webpack_public_path__ + "static/media/card.b459f7cd.jpg";